module.exports = __webpack_public_path__ + "img/CF_2W.1.7fba81c0.jpg";